import { CSSObject } from '@emotion/react';

export function getTicketTableCategoryStyles(): CSSObject {
    return {
        '&::first-letter': {
            textTransform: 'capitalize',
        },
    };
}
